module.exports = "{% extends 'base.html.twig' %}\n\n{% block title %}New enquiry{% endblock %}\n\n{% block body %}\n    <div class=\"form-container\">\n        <div class=\"form-holder\">\n            <h1>New enquiry</h1>\n            {{ form_start(form) }}\n            {{ form_widget(form) }}\n            {{ form_end(form) }}\n        </div>\n    </div>\n{% endblock %}"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/template-enquiry.txt
// module id = 658
// module chunks = 271754190448615